import React from 'react';
import { convertIcon } from '../component/Icon';

interface OverrideIconSize24 {
  size: '24';
}
type OverrideIconSize = OverrideIconSize24;

const SvgComponent = ({
  size,
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '24') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.94167 4.19187L8.466 4.34593L8.466 4.34593L8.94167 4.19187ZM9.20476 5.00416L8.72909 5.15822C8.79589 5.36446 8.98798 5.50416 9.20476 5.50416V5.00416ZM2.81573 4.27742L3.30319 4.38871L3.30319 4.38871L2.81573 4.27742ZM2.01858 5.52263C1.95712 5.79185 2.12554 6.05991 2.39475 6.12138C2.66397 6.18284 2.93204 6.01442 2.9935 5.74521L2.01858 5.52263ZM3.79065 4H7.99033V3H3.79065V4ZM8.466 4.34593L8.72909 5.15822L9.68043 4.85009L9.41734 4.0378L8.466 4.34593ZM9.20476 5.50416H19.506V4.50416H9.20476V5.50416ZM21.006 7.00416V9.66465H22.006V7.00416H21.006ZM2.32828 4.16614L2.01858 5.52263L2.9935 5.74521L3.30319 4.38871L2.32828 4.16614ZM19.506 5.50416C20.3345 5.50416 21.006 6.17573 21.006 7.00416H22.006C22.006 5.62344 20.8868 4.50416 19.506 4.50416V5.50416ZM7.99033 4C8.20711 4 8.3992 4.1397 8.466 4.34593L9.41734 4.0378C9.21695 3.41909 8.64068 3 7.99033 3V4ZM3.79065 3C3.09085 3 2.48403 3.48389 2.32828 4.16614L3.30319 4.38871C3.35511 4.1613 3.55738 4 3.79065 4V3Z"
          fill={color}
        />
        <path
          d="M12.4932 19.6231H19.506C20.6106 19.6231 21.506 18.7277 21.506 17.6231V8.24219H2.50604V11.511"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.13417 20.4486L6.84945 18.1779H5.73522V20.2669C5.73522 20.4706 5.57009 20.6358 5.3664 20.6358H4.96716C4.76346 20.6358 4.59833 20.4706 4.59833 20.2669V14.726C4.59833 14.5223 4.76346 14.3572 4.96716 14.3572H6.85018C7.55553 14.3572 8.16582 14.4728 8.59701 14.7593C9.0202 15.0405 9.28501 15.4957 9.28501 16.2149C9.28501 16.6914 9.1623 17.063 8.95265 17.3489C8.74255 17.6354 8.43935 17.8437 8.06568 17.9829L7.94373 18.0283L9.16367 20.0783C9.30997 20.3242 9.13281 20.6358 8.84671 20.6358H8.45518C8.32226 20.6358 8.19962 20.5643 8.13417 20.4486ZM6.72209 15.1671H5.73522V17.368H6.72209C7.17244 17.368 7.53646 17.2808 7.7899 17.0867C8.04866 16.8886 8.17556 16.5922 8.17556 16.2149C8.17556 15.8363 8.04738 15.5625 7.78303 15.3909C7.52916 15.226 7.16619 15.1671 6.72209 15.1671Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.082 14.8982V20.0948C3.082 20.3936 2.83979 20.6358 2.541 20.6358C2.24221 20.6358 2 20.3936 2 20.0948V14.8982C2 14.5994 2.24221 14.3572 2.541 14.3572C2.83979 14.3572 3.082 14.5994 3.082 14.8982Z"
          fill={color}
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 24 입니다.
 * 20(디폴트)사이즈가 없으므로 size prop은 required 입니다.
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'ir-deck');
export default IconComponent;
